import { useMemo } from "react";
import { sortBy } from "lodash";
import { useGetWorkspaceRolesQuery } from "~/graphql/supergraphHooks";
import { WorkspaceRow } from "./components/WorkspaceRolesTable";

export const useFetchWorkspaceRoles = () => {
  const result = useGetWorkspaceRolesQuery();

  const rowData: WorkspaceRow[] = useMemo(() => {
    if (result.data?.arenaAccessByRoleGroups?.__typename === "ArenaAccessByRoleGroupsOutput") {
      return sortBy(
        result.data.arenaAccessByRoleGroups.countByRoles.map((c) => ({
          role: c.roleGroupName,
          assignedUsers: c.count,
        })),
        ["role"],
      );
    } else {
      return [];
    }
  }, [result?.data]);

  return { rowData, result };
};
